<template>
  <app-layout :heading="$t('heading')">
    <v-card>
      <v-tabs color="white">
        <v-tab
          v-for="item in accountSettings"
          :to="{name: item.routeName}"
          :key="item.name"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-divider/>
      <v-flex>
        <router-view/>
      </v-flex>
    </v-card>
  </app-layout>
</template>

<script>
export default {
  name: 'CompanyOverview',
  data () {
    return {
      accountSettings: [
        { name: this.$t('info'), routeName: 'company.info' },
        { name: this.$t('salary'), routeName: 'company.salary' },
        { name: this.$t('log'), routeName: 'company.log' },
        { name: this.$t('deleteTimesheets'), routeName: 'company.deleteTimesheets' }
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        heading: 'Company overview',
        info: 'General information',
        log: 'Log',
        salary: 'Salary groups',
        deleteTimesheets: 'Remove timesheets'
      },
      tr: {
        heading: 'Şirket Bilgileri',
        info: 'Genel Bilgiler',
        log: 'Log',
        salary: 'Ücret Grupları',
        deleteTimesheets: 'Zaman çizelgelerini sil'
      },
      de: {
        heading: 'Firmenübersicht',
        info: 'Informationen',
        log: 'Log',
        salary: 'Lohngruppen',
        deleteTimesheets: 'Stundenzettel löschen'
      },
      ru: {
        heading: 'Обзор компании',
        info: 'Основная информация',
        log: 'Лог',
        salary: 'Зарплатные группы',
        deleteTimesheets: 'Удалить расписания'
      }
    }
  }
}
</script>

<style scoped>

</style>
